/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ events: NonNullable<unknown>, files: NonNullable<unknown> }} Letterpreviewsourcedfrom3Inputs */

const en_letterpreviewsourcedfrom3 = /** @type {(inputs: Letterpreviewsourcedfrom3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drafted from ${i?.events} timeline events you confirmed and ${i?.files} uploaded documents.`)
};

const pt_letterpreviewsourcedfrom3 = /** @type {(inputs: Letterpreviewsourcedfrom3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Redigida a partir de ${i?.events} eventos da cronologia que confirmou e ${i?.files} documentos carregados.`)
};

/**
* | output |
* | --- |
* | "Drafted from {events} timeline events you confirmed and {files} uploaded documents." |
*
* @param {Letterpreviewsourcedfrom3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewsourcedfrom3 = /** @type {((inputs: Letterpreviewsourcedfrom3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewsourcedfrom3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewsourcedfrom3(inputs)
	return pt_letterpreviewsourcedfrom3(inputs)
});
export { letterpreviewsourcedfrom3 as "letterPreviewSourcedFrom" }